<template>
  <div class="form-dialog">
    <el-dialog v-bind="$attrs"
               :title="dialogTitle"
               :visible.sync="dialogVisible"
               :width="dialogWidth"
               :before-close="handleClose"
               :show-close="showClose"
               :append-to-body="appendToBody"
               :close-on-click-modal="onClickModal"
               v-on="$listeners">
      <template slot="title">
        <slot name="title"></slot>
      </template>
      <form-combination v-if="isFormData"
                        :form-data="formData"
                        :label-width="labelWidth"
                        ref="formData"
                        :show-btn="showBtn"
                        v-on="$listeners"
                        @onclose="onClose"></form-combination>
      <slot></slot>
      <slot name="footer"></slot>
    </el-dialog>
  </div>
</template>

<script>
import formCombination from '@/components/iglobalwin/formCombination/formCombination';
export default {
  components: {
    formCombination,
  },
  props: {
    appendToBody: {
      default: false,
    },
    labelWidth: {
      default: '140px',
    },
    dialogWidth: {
      default: '450px',
    },
    dialogTitle: String,
    dialogVisible: {
      default: false,
    },
    onClickModal: {
      default: false,
    },
    showClose: {
      default: true,
    },
    showBtn: {
      default: false,
    },
    formData: {
      type: Object,
      default: undefined,
    },
  },
  computed: {
    isFormData: function (self) {
      return typeof self.formData != 'undefined'
    }
  },
  methods: {
    handleClose () {
      this.$emit('handleClose');
      this.$emit('update:dialogVisible', false);
    },
    onClose () {
      this.$emit('handleClose');
    },
    reset () {
      this.$refs.formData.reset();
    },
    clearValidate () {
      this.$refs.formData.clearValidate();
    },
    validate (valid) {
      this.$refs.formData.validate(valid);
    },
  },
};
</script>

<style scoped lang="scss">
.form-dialog {
	::v-deep  .el-dialog__wrapper {
		.el-dialog {
			.el-dialog__body {
				padding: 15px 20px;
			}
		}
	}
}
</style>
